import React from 'react';
import { Link } from 'react-router-dom';

import './DropdownJobItem.scss';

interface DropdownJobItemProps {
  // Href link of the item
  href?: string;
  jobId: string | React.ReactElement;
  title: string | React.ReactElement;
  icon: string | React.ReactElement;
  callback(status: boolean): void;
}

const DropdownJobItem: React.FC<DropdownJobItemProps> = props => {
  const {
    jobId,
    title,
    href,
    icon,
    callback = () => true
  } = props;

  return (
    <div styleName="user-dropdown-jobs-item">
      <Link to={href}
            data-tracking="customer-header-active-job-item"
            styleName="user-dropdown-jobs-item__link"
            onClick={() => callback(false)}
      >
        <div styleName="user-dropdown-jobs-item__icon">
          { typeof icon === 'string'
            ? <img styleName="user-dropdown-jobs-item__icon-img"
                   src={icon}
                   alt={typeof title === 'string' ? title : ''}
            />
            : icon
          }
        </div>
        <div styleName="user-dropdown-jobs-item__content">
          <div styleName="user-dropdown-jobs-item__title">{title}</div>
          <div styleName="user-dropdown-jobs-item__id">{typeof jobId === 'string' ? `#${jobId}` : jobId}</div>
        </div>
      </Link>
    </div>
  );
};

export default DropdownJobItem;
